module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"90.471 302.809 823 823\"><path d=\"M365.407 1022.185L90.677 747.457l67.883-67.882L365.406 886.42l479.977-479.988 67.883 67.882\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/CheckMarkIcon/CheckMarkIcon.svg
 ** module id = 697
 ** module chunks = 0
 **/